import { title } from "echarts/lib/theme/dark";

export default {
    categories: [
        {
            icon: "home",
            key: "home",
            route: "home",
            title: "Ana Sayfa",
        },
        {
            icon: "account_tree",
            key: "operational-process",
            title: "Operasyonel Süreçler",
        },
        {
            icon: "local_gas_station",
            key: "fuel-management",
            title: "Yakıt Yönetimi",
        },
        {
            icon: "settings",
            key: "system-parameters",
            title: "Sistem Parametreleri",
        },
        {
            icon: "inventory_2",
            key: "inventory-process",
            title: "Envanter İşlemleri",
        },
        {
            icon: "published_with_changes",
            key: "current-data",
            title: "Güncel Veriler",
        },
        {
            icon: "construction",
            key: "system-management",
            title: "Sistem Yönetimi",
        },
        {
            icon: "summarize",
            key: "reports",
            title: "Raporlar",
        },
        {
            icon: "manage_accounts",
            key: "employee_management",
            title: "Personel İşlemleri",
        },
        {
            icon: "security",
            key: "warranty_insurance",
            title: "Hasar ve Sigorta",
        },
        {
            icon: "receipt_long",
            key: "customer_draft_offer",
            route: "customer-draft-offer",
            title: "Teklif İşlemleri",
        },
        {
            title: "payments",
            key: "cost_center",
            title: "Maliyet Merkezi",
            icon: "account_balance_wallet",
        },
        {
            icon: "admin_panel_settings",
            key: "administrator",
            title: "Yönetici",
        },
        {
            icon: "account_balance",
            key: "vault-operations",
            title: "Kasa İşlemleri",
        },
        {
            icon: "web",
            key: "website-cms",
            title: "Website CMS",
        },
    ],
    items: [
        {
            category: "warranty_insurance",
            title: "Trafik Cezaları",
            children: [
                {
                    title: "Trafik Cezaları",
                    route: "traffic-fine",
                    icon: "directions",
                },
                {
                    title: "Onayımı Bekleyen Trafik Cezaları",
                    route: "traffic-fine-my-approvals",
                    icon: "av_timer",
                },
            ],
        },
        {
            category: "warranty_insurance",
            title: "Vukuat",
            children: [
                {
                    title: "Vukuat Listesi",
                    route: "incident",
                    icon: "report",
                },
                {
                    title: "Onayımı Bekleyen Vukuatlar",
                    route: "incident-my-approvals",
                    icon: "av_timer",
                },
                // {
                //     title: "Kayıt Parametre Kategorisi",
                //     route: "incident-case-category",
                //     icon: "category",
                // },
                // {
                //     title: "Kayıt Parametre Tipi",
                //     route: "incident-case-type",
                //     icon: "label",
                // },
                {
                    title: "Vukuat Parametreleri",
                    route: "incident-case-tree",
                    icon: "account_tree",
                },
            ],
        },
        {
            category: "system-parameters",
            title: "Firma Parametreleri",
            children: [
                {
                    title: "Sektör Tipi",
                    icon: "swipe",
                    route: "sector-type",
                },
            ],
        },
        {
            category: "system-parameters",
            title: "Araç Parametreleri",
            children: [
                {
                    title: "Marka",
                    icon: "branding_watermark",
                    route: "vehicle-brand",
                },
                {
                    title: "Model",
                    icon: "model_training",
                    route: "vehicle-brand-model",
                },
                {
                    title: "Model Serisi",
                    icon: "unfold_less",
                    route: "vehicle-brand-model-serial",
                },
                {
                    title: "Araç Tipi",
                    icon: "rv_hookup",
                    route: "vehicle-type",
                },
                {
                    title: "Araç Tanımlama",
                    route: "vehicle",
                    icon: "commute",
                },
                {
                    title: "Lastik Ölçüsü",
                    route: "tire-size",
                    icon: "tire_repair",
                },
            ],
        },
        {
            category: "system-parameters",
            title: "Operasyonel Parametreler",
            children: [
                {
                    title: "Araç Belge",
                    route: "vehicle-inventory-document-definition",
                    icon: "picture_as_pdf",
                },
                {
                    title: "Garaj",
                    route: "garage",
                    icon: "garage",
                },
                {
                    title: "Çalışma Grubu",
                    route: "working-group",
                    icon: "diversity_2",
                },
                {
                    title: "Nakliyeci Sınıfı",
                    route: "carrier-classification",
                    icon: "stroller",
                },
                {
                    title: "İcra Dairesi",
                    route: "op-levy-office",
                    icon: "point_of_sale",
                },
                {
                    title: "Vergi Ofisi",
                    route: "op-tax-administration",
                    icon: "assured_workload",
                },
                {
                    title: "Trafik Cezaları",
                    route: "traffic-fine-operation",
                    icon: "traffic",
                },
                {
                    title: "İl",
                    route: "op-province",
                    icon: "map",
                },
                {
                    title: "İl Endeks Kategorileri",
                    route: "op-province-index-category",
                    icon: "layers",
                },
                {
                    title: "İlçe",
                    route: "op-district",
                    icon: "map",
                },
                {
                    title: "Mahalle",
                    route: "op-neighborhood",
                    icon: "map",
                },
                {
                    title: "Sokak",
                    route: "op-street",
                    icon: "map",
                },
                {
                    title: "HGS Geçiş İşlemleri",
                    route: "op-hgs-gise",
                    icon: "toll",
                },
            ],
        },
        {
            category: "system-parameters",
            title: "Taşınabilir Yükler",
            children: [
                {
                    title: "Ana Grup",
                    route: "shipable-product-main-group",
                    icon: "group_work",
                },
                {
                    title: "Alt Grup",
                    route: "shipable-product-sub-group",
                    icon: "category",
                },
                {
                    title: "Yük Şekli",
                    route: "shipable-product-form",
                    icon: "dashboard",
                },
                {
                    title: "Tehlike Sınıfı",
                    route: "shipable-product-danger-class",
                    icon: "local_fire_department",
                },
                {
                    title: "Değer Sınıfı",
                    route: "shipable-product-value-class",
                    icon: "diamond",
                },
                {
                    title: "Yükleme Modu",
                    route: "shipable-product-load-mode",
                    icon: "publish",
                },
                {
                    title: "Yükleme Tipi",
                    route: "shipable-product-load-type",
                    icon: "vertical_align_center",
                },
                {
                    title: "Yük",
                    route: "shipable-product",
                    icon: "inventory_2",
                },
            ],
        },
        {
            category: "system-parameters",
            title: "Sistem Değişkenleri",
            children: [
                {
                    title: "Sistem Sabitleri",
                    route: "system-constant-parameters",
                    icon: "data_object",
                },
                {
                    title: "İnsan Kaynakları Sabitleri",
                    route: "hr-constant-parameters",
                    icon: "data_object",
                },
                {
                    title: "Total Yakıt Filosu",
                    route: "total-fleet",
                    icon: "meeting_room",
                },
            ],
        },
        {
            category: "system-parameters",
            title: "İnsan Kaynakları",
            children: [
                // {
                //     title:"Maliyet Merkezi",
                //     route:'hr-expense-location',
                //     icon:'local_atm'
                // },
                // {
                //     title:"Görev Yeri",
                //     route:'hr-task-area',
                //     icon:'person_pin_circle'
                // },
                {
                    title: "Beden Bilgileri",
                    route: "hr-size-information",
                    icon: "straighten",
                },
                {
                    title: "Beden Değerleri",
                    route: "hr-size-information-parameters",
                    icon: "square_foot",
                },
                // {
                //     title:"Banka",
                //     route:'hr-bank',
                //     icon:'account_balance'
                // },
                // {
                //     title:"Banka Şubeleri",
                //     route:'hr-bank-branch',
                //     icon:'foundation'
                // },
                {
                    title: "Çalışan Yetkinliği",
                    route: "hr-employee-proficiency",
                    icon: "sign_language",
                },
                {
                    title: "Çalışan Yetkinliği Parametreleri",
                    route: "hr-employee-proficiency-parameters",
                    icon: "waving_hand",
                },
                {
                    title: "Şube",
                    route: "hr-branch",
                    icon: "apartment",
                },
                {
                    title: "Bölüm ve Bölüm Unvanı",
                    route: "hr-employee-department",
                    icon: "business",
                },
                {
                    title: "Personel Belge",
                    route: "employee-document",
                    icon: "picture_as_pdf",
                },
                {
                    title: "Kişisel Koruyucu Donanımlar",
                    route: "hr-personal-protective-equipment",
                    icon: "home_repair_service",
                },
                // {
                //     title:"KYKM Tür Grupları",
                //     route:'hr-salary-effect-type-group',
                //     icon:'money'
                // },
                // {
                //     title:"KYKM Türleri",
                //     route:'hr-salary-effect-type',
                //     icon:'paid'
                // },
                {
                    title: "KYKM",
                    route: "hr-kykm",
                    icon: "paid",
                },
                {
                    title: "İzin Türleri",
                    route: "hr-excuse-type",
                    icon: "fact_check",
                },
                // {
                //     title:"Netsis Hesap Kodu",
                //     route:'hr-netsis-account-code',
                //     icon:'supervised_user_circle'
                // },
                {
                    title: "Prim Türü",
                    route: "hr-bonus-payment-type",
                    icon: "savings",
                },
                {
                    title: "İşten Çıkış Sebebi Türü",
                    route: "hr-job-exit-cause",
                    icon: "flaky",
                },
                {
                    title: "İşten Çıkış Özel Sebebi",
                    route: "hr-job-exit-special-cause",
                    icon: "flaky",
                },
                {
                    title: "Mesai Saatleri",
                    route: "hr-shift-time",
                    icon: "update",
                },
                {
                    title: "Brüt Hesaplama Parametreleri",
                    route: "hr-brut-calculate",
                    icon: "add_task",
                },
                {
                    title: "Vukuat Türü",
                    route: "hr-incident-reason",
                    icon: "crisis_alert",
                },
                // {
                //     title:"Eksik Gün",
                //     route:'hr-eksik-gun',
                //     icon:'free_cancellation'
                // },
                {
                    title: "SGK Eksik Gün",
                    route: "hr-sgk-eksik-gun",
                    icon: "free_cancellation",
                },
                {
                    title: "Resmi Tatiller",
                    route: "hr-public-holiday",
                    icon: "beach_access",
                },
                {
                    title: "Luca Gün Kodları",
                    route: "hr-luca-day-code",
                    icon: "merge_type",
                },
                {
                    title: "Arıza Tipi Ana Grubu",
                    route: "hr-fault-type-group",
                    icon: "disc_full",
                },
                {
                    title: "Yönetsel Düzey Grupları",
                    route: "administrative-level-group",
                    icon: "nature",
                },
                {
                    title: "Yönetsel Düzeyler",
                    route: "administrative-level",
                    icon: "lan",
                },
                {
                    title: "Sağlık Raporu Takip Gerekçesi",
                    route: "health-report-surveillance-reason",
                    icon: "monitor_heart",
                },
                {
                    title: "Tehlike Sınıfı",
                    route: "hazard-class",
                    icon: "report_gmailerrorred",
                },
                {
                    title: "İSG Eğitimi",
                    route: "ohs-education",
                    icon: "school",
                },
                {
                    title: "SRC Belge Türleri",
                    route: "src-types",
                    icon: "sports_motorsports",
                },
                {
                    title: "İşten Çıkış Onay Seviyeleri",
                    route: "hr-sgk-exit-approval",
                    icon: "schema",
                },
            ],
        },
        {
            category: "system-parameters",
            title: "Bakım Onarım",
            children: [
                {
                    title: "Ana Grup",
                    route: "maintenance-main-group",
                    icon: "group_work",
                },
                {
                    title: "Alt Grup",
                    route: "maintenance-sub-group",
                    icon: "category",
                },
                {
                    title: "Parça",
                    route: "maintenance-part-of",
                    icon: "webhook",
                },
            ],
        },
        {
            category: "inventory-process",
            title: "Araç Envanter İşlemleri",
            route: "vehicle-inventory-definition",
            icon: "featured_play_list",
        },
        {
            category: "inventory-process",
            title: "Plaka İşlem Geçmişi",
            route: "vehicle-plate-history",
            icon: "history",
        },
        {
            category: "inventory-process",
            title: "Operasyonel Araç Envanteri İşlemleri",
            route: "vehicle-inventory-operational",
            icon: "track_changes",
        },
        {
            category: "inventory-process",
            title: "Plaka Envanteri",
            route: "plate",
            icon: "tablet",
        },
        // {
        //     category: "current-data",
        //     title: "Yakıt Fiyatları",
        //     route: "fuel-prices",
        //     icon: "local_gas_station",
        // },
        {
            category: "current-data",
            title: "Döviz Kurları",
            route: "currency",
            icon: "currency_exchange",
        },
        {
            category: "current-data",
            title: "Enflasyon Göstergeleri",
            route: "inflation",
            icon: "query_stats",
        },
        {
            category: "system-management",
            title: "Rol Yönetimi",
            route: "role",
            icon: "settings_accessibility",
        },
        {
            category: "system-management",
            title: "Mail Yönetimi",
            route: "mail-settings",
            icon: "mail_outline",
        },
        {
            category: "system-management",
            title: "Kullanıcı İşlem Geçmişi",
            route: "user-action-log",
            icon: "sync_alt",
        },
        {
            category: "system-management",
            title: "Entegrasyon Bilgileri",
            route: "integration-information",
            icon: "integration_instructions",
        },
        {
            category: "system-management",
            title: "Kullanıcı Yönetimi",
            route: "user",
            icon: "account_circle",
        },
        {
            category: "system-management",
            title: "Belge Şablonları",
            route: "template",
            icon: "space_dashboard",
        },
        {
            category: "system-management",
            title: "Mobil Cihaz Yönetimi",
            route: "mobile-app",
            icon: "tablet_android",
        },
        {
            category: "reports",
            title: "Narlı Feribot Bilgileri",
            children: [
                {
                    title: "Geçiş Bilgileri",
                    route: "narli-ferryboat",
                    icon: "directions_boat",
                },
                {
                    title: "Günlük Bazda - İşlem Tipine Göre Rapor",
                    route: "narli-ferryboat-stats-by-process-type",
                    icon: "credit_card",
                },
                {
                    title: "Günlük Bazda - Araç Tipine Göre Rapor",
                    route: "narli-ferryboat-stats-by-vehicle-type",
                    icon: "local_shipping",
                },
                {
                    title: "Tarih Aralığına Göre Özet Rapor",
                    route: "narli-ferryboat-stats-by-date-range-summary",
                    icon: "auto_graph",
                },
                // {
                //     title:"Günlük Bazda - Plakaya Göre Rapor",
                //     route:'narli-ferryboat-stats-by-plate',
                //     icon:'tablet',
                // }
            ],
        },
        {
            category: "reports",
            title: "İş Bankası HGS Bilgileri",
            children: [
                {
                    title: "Geçiş Bilgileri",
                    route: "isbankasi-hgs",
                    icon: "toll",
                },
                {
                    title: "Yükleme Bilgileri",
                    route: "isbankasi-hgs-charge",
                    icon: "credit_score",
                },
            ],
        },
        // {
        //     category: "reports",
        //     title: "Total Bilgileri",
        //     children: [
        //         {
        //             title: "Yakıt Yükleme Bilgileri",
        //             route: "total-fuel-load",
        //             icon: "oil_barrel",
        //         },
        //     ],
        // },
        {
            category: "reports",
            title: "Personel",
            children: [
                {
                    title: "Personel",
                    route: "employee-basic-report",
                    icon: "groups_3",
                },
                {
                    title: "Personel Raporu",
                    route: "personnel-report",
                    icon: "groups_3",
                },
                {
                    title: "Organizasyonel Şema",
                    route: "org-chart",
                    icon: "account_tree",
                },
                {
                    title: "İSG Eğitimi",
                    route: "ohs-report",
                    icon: "emergency",
                },
                {
                    title: "SRC",
                    route: "src-report",
                    icon: "emergency",
                },
                {
                    title: "Sağlık Raporu",
                    route: "health-report-report",
                    icon: "emergency",
                },
                {
                    title: "Psikoteknik",
                    route: "psychotechnic-report",
                    icon: "emergency",
                },
                {
                    title: "Dijital Ehliyet Takip",
                    route: "digital-driver-license-report",
                    icon: "badge",
                },
                {
                    title: "Ehliyet Takip",
                    route: "driver-license-report",
                    icon: "badge",
                },
                {
                    title: "Arabuluculuk Raporu",
                    route: "mediation-report",
                    icon: "handshake",
                },
                {
                    title: "Banka 2 Maaş Bordro Yükleme Takip",
                    route: "report-g-salary-report",
                    icon: "document_scanner",
                },
                {
                    title: "Ek Hakediş Raporu",
                    route: "ek-hakedis-report",
                    icon: "restaurant",
                },
                {
                    title: "Maaş Bilgileri Raporu",
                    route: "maas-bilgileri-report",
                    icon: "payments",
                },
                {
                    title: "Sicil Dosyası Takip",
                    route: "report-registry-document",
                    icon: "document_scanner",
                },
                {
                    title: "Sicil Belgeleri Takip",
                    route: "report-sicil-file",
                    icon: "document_scanner",
                },
                {
                    title: "Çıkış Evrakları Takip",
                    route: "report-exit-file",
                    icon: "logout",
                },
                {
                    title: "Performans Ceza Puanı Raporu",
                    route: "employee-traffic-fine-performance-report",
                    icon: "traffic",
                },
                {
                    title: "Resmi Ceza Puanı Raporu",
                    route: "employee-traffic-fine-official-report",
                    icon: "traffic",
                },
            ],
        },
        {
            category: "reports",
            title: "İl Katsayıları",
            route: "report-province-indexes",
            icon: "share_location",
        },
        {
            category: "reports",
            title: "Organizasyonel Düzeylere Göre Yemek Ücretleri",
            route: "report-meal-prices-based-by-organisational-location",
            icon: "restaurant",
        },
        {
            category: "reports",
            title: "Organizasyonel Düzeylere Göre Yol Ücretleri",
            route: "report-road-prices-based-by-organisational-location",
            icon: "timeline",
        },
        {
            category: "operational-process",
            title: "Fiyat Çalışma",
            children: [
                {
                    title: "Lastik Referans Model",
                    route: "tire-reference-model",
                    icon: "circle",
                },
                {
                    title: "Araç Referans Model",
                    route: "vehicle-reference-model",
                    icon: "architecture",
                },
                {
                    title: "Taslak Fiyat",
                    route: "draft-price",
                    icon: "design_services",
                },
            ],
        },
        {
            category: "employee_management",
            title: "Takograf",
            children: [
                {
                    title: "Tüm Sürücü Bilgileri",
                    icon: "contact_emergency",
                    route: "tachograph-driver-operations",
                },
                {
                    title: "Tüm Araç Bilgileri",
                    icon: "car_repair",
                    route: "tachograph-vehicle-operations",
                },
                {
                    title: "Sürücü Çalışma Zamanı",
                    icon: "timelapse",
                    route: "tachograph-driver-working-time",
                },
                {
                    title: "Hatalı Sürücü Verileri",
                    icon: "rule",
                    route: "tachograph-wrong-driver-data",
                },
                {
                    title: "Envanter Dışı Plakalar",
                    icon: "align_vertical_top",
                    route: "tachograph-out-of-inventory-plate-data",
                },
                {
                    title: "Araç Sürücü Ehliyet Hareketleri",
                    icon: "badge",
                    route: "tachograph-vehicle-driver-card-movement",
                },
                {
                    title: "Sürücü Yükleme Takip",
                    icon: "cloud_sync",
                    route: "tachograph-upload-tracing",
                },
                {
                    title: "Seyir Surucu Dosya Takip",
                    icon: "cloud_download",
                    route: "seyir-driver-download-tracing",
                },
            ],
        },
        {
            category: "operational-process",
            title: "Firma",
            children: [
                {
                    title: "Firma İşlemleri",
                    route: "firm-operations",
                    icon: "add_business",
                },
                {
                    title: "Ana Firma İşlemleri",
                    route: "firm-operations-parent",
                    icon: "cottage",
                },
            ],
        },
        {
            category: "system-parameters",
            title: "Banka Hesapları",
            icon: "assured_workload",
            route: "company-bank-account",
        },
        {
            category: "system-parameters",
            title: "Vukuat Onay Kuralları",
            icon: "rule",
            route: "incident-approval-configuration",
        },
        {
            category: "system-parameters",
            title: "Trafik Cezası Onay Kuralları",
            icon: "rule",
            route: "traffic-fine-approval-configuration",
        },
        {
            category: "cost_center",
            title: "Personel Maliyetleri",
            children: [
                {
                    title: "Personel Maliyet",
                    route: "employee-reports-expense",
                    icon: "currency_exchange",
                },
                {
                    title: "Personel Aylık Maliyet",
                    route: "employee-reports-expense-monthly",
                    icon: "currency_exchange",
                },
            ],
        },
        {
            category: "fuel-management",
            title: "Dışarıdan Alınan Yakıtlar",
            route: "buying-fuel",
            icon: "add_shopping_cart",
        },
        {
            category: "fuel-management",
            title: 'Araçtan Yakıt Tahliyesi/Transferi',
            route: 'transfer-fuel',
            icon: 'sync_alt',
        },
        {
            category: "fuel-management",
            title: "Yakıt Siparişleri",
            route: "fuel-storage-order",
            icon: "local_gas_station",
        },
        {
            category: "fuel-management",
            title: "Yakıt Girişi",
            route: "fuel-storage-filling",
            icon: "add_circle",
        },
        {
            category: "fuel-management",
            title: "Yakıt Çıkışı",
            route: "fuel-storage-withdrawal",
            icon: "do_not_disturb_on",
        },
        {
            category: "fuel-management",
            title: "Depolar Arası Transfer",
            route: "fuel-storage-transfer",
            icon: "compare_arrows",
        },
        {
            category: "fuel-management",
            title: "Depo Hareketleri",
            route: "fuel-storage-transaction",
            icon: "swap_horiz",
        },
        {
            category: "fuel-management",
            title: "Yakıt Tedarikçileri",
            route: "fuel-supplier",
            icon: "local_shipping",
        },
        {
            category: "fuel-management",
            title: "Yakıt Fiyatları",
            route: "fuel-prices",
            icon: "price_change",
        },
        {
            category: "fuel-management",
            title: "Total",
            route: "total-fuel-load",
            icon: "oil_barrel",
        },
        {
            category: "fuel-management",
            title: "Petrol Ofisi",
            route: "po-fuel-load",
            icon: "oil_barrel",
        },
        {
            category: "fuel-management",
            title: "Raporlar",
            children: [
                {
                    title: "Yakıt Çıkışları",
                    route: "fuel-output-report",
                    icon: "summarize",
                },
                {
                    title: "Depo Doluluk Seviyeleri",
                    route: "fuel-storage-occupancy-bar-chart-report",
                    icon: "bar_chart",
                },
                {
                    title: "Depo Doluluk Raporu",
                    route: "fuel-storage-occupancy-report",
                    icon: "data_usage",
                },
                {
                    title: "Depo Durum Raporu",
                    route: "fuel-storage-stock-status-report",
                    icon: "stacked_bar_chart",
                },
                {
                    title: "Plaka Bazlı Yakıt Alımları",
                    route: "fuel-consumption-by-plate",
                    icon: "local_gas_station",
                },
                {
                    title: "Görev Yeri Bazlı Yakıt Alımları",
                    route: "fuel-consumption-by-duty-location",
                    icon: "location_on",
                },
                {
                    title: "Şube Bazlı Yakıt Alımları",
                    route: "fuel-consumption-by-branch",
                    icon: "business",
                },
                {
                    title: "Şirket Geneli Yakıt Alımları",
                    route: "fuel-consumption-company-total",
                    icon: "assessment",
                },
            ],
        },

        // {
        //     title: "Sipariş İşleme Formu",
        //     route: "fuel-order-document-form",
        //     icon: "align_horizontal_left",
        // },
        // {
        //     title: "Depo Hareket Detayları",
        //     route: "fuel-storage-transaction-detail",
        //     icon: "list_alt"
        // },
        {
            category: "fuel-management",
            title: "Tanımlamalar",
            children: [
                {
                    title: "Akaryakıt Depoları",
                    route: "fuel-storage",
                    icon: "gas_meter",
                },
                {
                    title: "Entegre Depo Sınıfı",
                    route: "integrated-storage-class",
                    icon: "propane",
                },
                {
                    title: "Depo Sınıfı",
                    route: "fuel-storage-class",
                    icon: "propane",
                },
                {
                    title: "Petrol Ofisi Filo",
                    route: "po-filo-codes",
                    icon: "local_shipping",
                },
            ],
        },
        {
            category: "fuel-management",
            title: "Parametreler",
            children: [
                {
                    title: "Tedarikçi Sözleşmeleri",
                    route: "supplier-agreement",
                    icon: "handshake",
                },
                {
                    title: "İskonto Tanımlama",
                    route: "supplier-iskonto",
                    icon: "price_change",
                },
                {
                    title: "Kredi Kartı Tanımlama",
                    route: "credit-card-information",
                    icon: "credit_card",
                },
                {
                    title: "Rafineri Fiyatları",
                    route: "refinery-price",
                    icon: "oil_barrel",
                },
            ],
        },
        {
            category: "fuel-management",
            title: "Vardiyalar",
            children: [
                {
                    title: "Tüm Vardiya Bilgileri",
                    route: "all-shifts",
                    icon: "work",
                },
                {
                    title: "Benim Vardiya Bilgilerim",
                    route: "my-shifts",
                    icon: "work_history",
                },
            ],
        },
        {
            category: "operational-process",
            title: "CBS Verileri",
            children: [
                {
                    title: "Canlı Araç Takip",
                    route: "seyir-actual-location",
                    icon: "stream",
                },
                {
                    title: "**Lokasyon Kayıtları (Geçmişe Dönük)",
                    route: "seyir-location-logs",
                    icon: "near_me",
                },
                {
                    title: "**Lokasyon Kayıtları (Araç)(Gün Aralığı)",
                    route: "seyir-location-logs-for-vehicle",
                    icon: "near_me",
                },
                {
                    title: "**Lokasyon Kayıtları (Araç)(Gün)",
                    route: "seyir-location-logs-for-vehicle-by-date",
                    icon: "near_me",
                },
                {
                    title: "**Performans Raporu (Gün)(Saat Aralığı)",
                    route: "seyir-performance-report",
                    icon: "shutter_speed",
                },
                {
                    title: "**Performans Raporu (Gün Aralığı)(Saat Aralığı)",
                    route: "seyir-date-range-performance-report",
                    icon: "shutter_speed",
                },
                {
                    title: "**Araç Detay Raporu (Gün)",
                    route: "seyir-vehicle-detail-report",
                    icon: "summarize",
                },
                {
                    title: "**Alan Raporu (Gün)",
                    route: "seyir-area-report",
                    icon: "area_chart",
                },
                {
                    title: "**Alan Raporu ve Alan Girişler (Gün Aralığı)",
                    route: "seyir-area-report-and-area-entrances",
                    icon: "area_chart",
                },
            ],
        },
        {
            category: "operational-process",
            title: "Sözleşme",
            route: "agreement",
            icon: "draw",
        },
        {
            category: "employee_management",
            title: "Personel Yönetimi",
            children: [
                {
                    title: "Personel",
                    route: "employee",
                    icon: "people",
                },
                {
                    title: "Eşleşmeyen Personel",
                    route: "not-matched-employee",
                    icon: "group_off",
                },
                {
                    title: "Atanmayan Personel",
                    route: "not-assigned-employee",
                    icon: "person_add_disabled",
                },
            ],
        },
        {
            category: "employee_management",
            title: "Atama",
            children: [
                {
                    title: "Şube İnsan Kaynakları Sorumlusu",
                    route: "branch-human-resources-assign",
                    icon: "assignment_ind",
                },
            ],
        },
        {
            category: "employee_management",
            title: "Puantaj",
            children: [
                // {
                //     title:"Günlük",
                //     route:'daily-score',
                //     icon:'scoreboard'
                // },
                {
                    title: "Günlük",
                    route: "daily-score-by-date",
                    icon: "settings_input_component",
                },
                {
                    title: "Günlük Düzenleme",
                    route: "daily-score-edit",
                    icon: "edit_calendar",
                },
                {
                    title: "Sürücü Günlük Takip",
                    route: "daily-score-tracing",
                    icon: "analytics",
                },
                {
                    title: "İdari Günlük Takip",
                    route: "not-dirver-daily-score-tracing",
                    icon: "analytics",
                },
                {
                    title: "Sürücü Maaşa Esas Aylık",
                    route: "monthly-score",
                    icon: "sports_score",
                },
                {
                    title: "İdari Maaşa Esas Aylık",
                    route: "not-driver-monthly-score",
                    icon: "sports_score",
                },
                // {
                //     title:"Luca Karşılaştırma",
                //     route:'luca-comparation',
                //     icon:'difference'
                // },
            ],
        },
        {
            category: "employee_management",
            title: "Maaş Faktörleri",
            children: [
                {
                    category: "employee_management",
                    title: "Uygulanan Maaş (Garaj)",
                    route: "garage-salary",
                    icon: "point_of_sale",
                },
                {
                    category: "employee_management",
                    title: "İcralar",
                    route: "levy",
                    icon: "card_travel",
                },
                {
                    category: "employee_management",
                    title: "BES",
                    route: "employee-bes",
                    icon: "elderly",
                },
                {
                    category: "employee_management",
                    title: "Fazla Mesai",
                    route: "fm",
                    icon: "edit_calendar",
                },
                // {
                //     category:"employee_management",
                //     title:"Ticket",
                //     route:'employee-ticket',
                //     icon:'restaurant'
                // },
            ],
        },
        {
            category: "employee_management",
            title: "KYKM",
            children: [
                {
                    title: "Atamalar",
                    route: "advance-payment",
                    icon: "payments",
                },
                {
                    title: "Atama Kuralları",
                    route: "advance-payment-rules",
                    icon: "gavel",
                },
            ],
        },
        {
            category: "employee_management",
            title: "Maaş",
            children: [
                // {
                //     title:"Maaş Hesaplama Süreci",
                //     route:'calculate-salary-process',
                //     icon:'account_tree'
                // },
                {
                    title: "Banka 1",
                    route: "calculate-salary-process",
                    icon: "account_tree",
                },
                {
                    title: "Banka 1 Maaş Kilit",
                    route: "salary-lock",
                    icon: "lock",
                },
                {
                    title: "Ertelenen Banka 1 Maaş Ödemeleri",
                    route: "excepted-r-salary-payment",
                    icon: "payments",
                },
                {
                    title: "Banka 2",
                    route: "calculate-salary-process-g",
                    icon: "account_tree",
                },
                {
                    title: "Yurt İçi Sürücü Maaşı",
                    route: "domestic-driver-salary",
                    icon: "local_shipping",
                },
                {
                    title: "Ek Hakediş Yükleme",
                    route: "man-allowance-upload",
                    icon: "upload_file",
                },
                {
                    title: "Banka 2 Maaş Kilit",
                    route: "g-salary-lock",
                    icon: "lock",
                },
                {
                    title: "Kasa Dekont",
                    route: "kasa-dekont",
                    icon: "receipt_long",
                },
                // {
                //     title:"G Maaş",
                //     route:'employee-g-salary',
                //     icon:'table_rows'
                // },
                // {
                //     title:"G Maaş Yükleme",
                //     route:'employee-g-salary-upload',
                //     icon:'table_rows'
                // },
                {
                    title: "Son Maaş Tablosu",
                    route: "employee-salary",
                    icon: "table_rows",
                },
                {
                    title: "Maaş Ödemesi",
                    route: "employee-salary-payment",
                    icon: "payments",
                },
                {
                    title: "Toplu Maaş Güncelleme",
                    route: "garage-salary-multiple",
                    icon: "view_headline",
                },
            ],
        },
        {
            category: "employee_management",
            title: "İzin",
            children: [
                // {
                //     title:'İzin Takvimi',
                //     route:'excuse',
                //     icon:'event',
                // },
                {
                    title: "İzinler",
                    route: "excuse-gantt",
                    icon: "event",
                },
                {
                    title: "Saatlik İzinler",
                    route: "excuse-gantt-hourly",
                    icon: "alarm",
                },
                {
                    title: "Yıllık İzin",
                    route: "excuse-annual",
                    icon: "beach_access",
                },
                {
                    title: "Belge Bekleyen İzinler",
                    route: "excuse-waiting-document",
                    icon: "document_scanner",
                },
            ],
        },
        // {
        //     category:"employee_management",
        //     title:"Form",
        //     route:'form',
        //     icon:'fact_check'
        // },
        {
            category: "employee_management",
            title: "Ödeme",
            children: [
                {
                    title: "Banka Dosyası Kimlikleri",
                    route: "advance-payment-group-key",
                    icon: "price_check",
                },
                {
                    title: "Gruplar",
                    route: "salary-group",
                    icon: "payments",
                },
            ],
        },
        {
            category: "employee_management",
            title: "Arabuluculuk",
            route: "mediation",
            icon: "handshake",
        },
        {
            category: "employee_management",
            title: "Eski Çıkış Kayıtları Düzenleme",
            route: "old-exit-completion",
            icon: "edit_note",
        },
        {
            category: "employee_management",
            route: "employee-sgk-exit-my-approvals",
            title: "Onayımı Bekleyen Çıkışlar",
            icon: "av_timer",
        },
        {
            category: "administrator",
            title: "Sicil Dosyası Değerleri",
            route: "admin-registry-document-value",
            icon: "data_object",
        },
        {
            category: "vault-operations",
            title: "Netsis Kasa Parametreleri",
            children: [
                {
                    title: "Muhasebe Hesap Planı",
                    route: "vault-muhasebe-plani",
                    icon: "account_tree",
                },
                {
                    title: "Netsis Kasa Kullanıcıları",
                    route: "user-of-netsis-vault",
                    icon: "admin_panel_settings",
                },
                {
                    title: "Netsis Kasa Hesap Planı",
                    route: "vault-kasa-hesap-plani",
                    icon: "account_tree",
                },
                {
                    title: "Kasa Rapor Kodu",
                    route: "vault-report-code",
                    icon: "ssid_chart",
                },
                {
                    title: "Trafik Cezası Hesap Planı",
                    route: "vault-trafik-cezasi-plani",
                    icon: "account_tree",
                },
                {
                    title: "Banka Hesap Planı",
                    route: "vault-banka-plani",
                    icon: "account_tree",
                },
                {
                    title: "Belge Türü",
                    route: "vault-belge-turu",
                    icon: "file_copy",
                },
                {
                    title: "Hesap Eşleşmesi",
                    route: "vault-account-pair",
                    icon: "earbuds",
                },
            ],
        },
        {
            category: "vault-operations",
            title: "Netsis Kasa İşlemleri",
            children: [
                {
                    title: "Personel Maaş Ödeme",
                    route: "employee-payment",
                    icon: "local_atm",
                },
                {
                    title: "Kasa Hareketleri",
                    route: "vault-actions",
                    icon: "sync_alt",
                },
                {
                    title: "Cari İşlemi",
                    route: "cari-vault-action",
                    icon: "radio_button_checked",
                },
                {
                    title: "Banka İşlemi",
                    route: "bank-vault-action",
                    icon: "account_balance",
                },
                {
                    title: "Muhtelif İşlemleri",
                    route: "muhtelif-vault-action",
                    icon: "shuffle",
                },
                {
                    title: "Transfer İşlemleri",
                    route: "transfer-vault-action",
                    icon: "swap_horiz",
                },
                {
                    title: "Fatura",
                    route: "invoice-vault-action",
                    icon: "request_quote",
                },
            ],
        },
        {
            category: "vault-operations",
            title: "Kasa Kilitleme",
            route: "vault-lock",
            icon: "lock",
        },

        {
            category: "vault-operations",
            title: "Trafik Cezası Ödemeleri",
            route: "vault-traffic-fine",
            icon: "traffic",
        },
        {
            category: "vault-operations",
            title: "Banka 2 Avans",
            route: "banka-2-avans",
            icon: "payments",
        },
        {
            category: "vault-operations",
            title: "Cariler",
            route: "caris",
            icon: "social_distance",
        },
        {
            category: "vault-operations",
            title: "Kasa Raporu",
            route: "vault-report",
            icon: "assessment",
        },
        {
            category: "vault-operations",
            title: "Personel Yıllık Cari Hesap",
            route: "employee-balance",
            icon: "currency_exchange",
        },
        // Website İçerik Yönetimi
        {
            category: "website-cms",
            icon: "dashboard",
            route: "website-dashboard",
            title: "Website Dashboard",
        },
        // İçerik Yönetimi
        {
            category: "website-cms",
            icon: "article",
            route: "website-content",
            title: "İçerik Yönetimi",
        },
        // Galeri Yönetimi
        {
            category: "website-cms",
            icon: "folder_open",
            route: "website-gallery",
            title: "Dosya Yönetimi",
        },
        // Navigasyon Yönetimi
        {
            category: "website-cms",
            icon: "menu",
            route: "website-navigation",
            title: "Navigasyon Yönetimi",
        },
        // Dil Yönetimi
        {
            category: "website-cms",
            icon: "translate",
            route: "website-language",
            title: "Dil Yönetimi",
        },
        // Site Ayarları
        {
            category: "website-cms",
            icon: "settings_suggest",
            route: "website-configuration",
            title: "Global Değerler",
        },
    ],
};
